import React, { Component } from "react";
import { Modal, Button, Form } from "react-bootstrap";

/** Longest range (in calendar days, inclusive) one export may cover. */
export const MAX_EXPORT_DAYS = 92;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Returns the validation message for a From / To pair, or null when the pair is exportable.
 */
export const validateRange = (from, to) => {
  if (!from || !to) {
    return "Please select both dates";
  }

  const start = Date.parse(from + "T00:00:00Z");
  const end = Date.parse(to + "T00:00:00Z");

  if (Number.isNaN(start) || Number.isNaN(end)) {
    return "Please select both dates";
  }
  if (end < start) {
    return "To date must be on or after From date";
  }
  if (Math.round((end - start) / MS_PER_DAY) + 1 > MAX_EXPORT_DAYS) {
    return "Please select a range of " + MAX_EXPORT_DAYS + " days or less";
  }
  return null;
};

/**
 * Dialog opened from the Multi Clock-in History page (EVOX-1015).
 * Lets the employee pick a From / To date and hands the pair back through onExport.
 * The parent owns the API call and the download; this component only owns the inputs.
 */
class ExportPunchLogsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from: props.defaultStart || "",
      to: props.defaultEnd || "",
    };
  }

  componentDidUpdate(prevProps) {
    // Every time the dialog is (re)opened, start from the range the page currently shows.
    if (this.props.show && !prevProps.show) {
      this.setState({
        from: this.props.defaultStart || "",
        to: this.props.defaultEnd || "",
      });
    }
  }

  handleFromChange = (event) => {
    this.setState({ from: event.target.value });
  };

  handleToChange = (event) => {
    this.setState({ to: event.target.value });
  };

  handleExport = () => {
    const { from, to } = this.state;
    if (validateRange(from, to) !== null) {
      return;
    }
    this.props.onExport(from, to);
  };

  render() {
    const { show, onHide } = this.props;
    const { from, to } = this.state;
    const error = validateRange(from, to);

    return (
      <Modal className="remark-modal export-punch-logs-modal" show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Export Multi Clock-in Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="export-punch-logs-from">
            <Form.Label>From</Form.Label>
            <Form.Control type="date" name="from" value={from} onChange={this.handleFromChange} />
          </Form.Group>
          <Form.Group controlId="export-punch-logs-to">
            <Form.Label>To</Form.Label>
            <Form.Control type="date" name="to" value={to} onChange={this.handleToChange} />
          </Form.Group>
          {error ? (
            <div className="text-danger export-punch-logs-error" role="alert">
              {error}
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleExport} disabled={error !== null}>
            Export
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ExportPunchLogsModal;
